<template>
  <div class="stepBox">
    <qiangzhi :type="3"/>
    <fengxian :type="3" />
    <fuwu :type="3" />
    <mElectronicFooter ref="footer" @nextClick="nextClick"/>
  </div>
</template>

<script>
import mixins from "./mixins";
export default {
  mixins: [mixins],
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    nextClick(){
      this.$refs.footer.next()
    }
  },
};
</script>

<style scoped lang="scss">
@use "~@/views/hetongqianshu/step/index.scss" as *;
</style>
